import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { Assistance, AssistanceDTO } from '../../models/assistance.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../request/request';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class ServiceAssistance {
    httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'assistances/';
  url = environment.service_1 + 'all-assistences/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedAssistance = new BehaviorSubject<Assistance | null>(null);
  selectedAssistance$ = this.selectedAssistance.asObservable();

  private assistances = new BehaviorSubject<Assistance[]>([]);
  assistances$ = this.assistances.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setAssistance(assistance: Assistance) {
    this.selectedAssistance.next(assistance);
  }

  setAssistances(assistances: Assistance[]) {
    this.assistances.next(assistances);
  }

  removeAssistanceSelected() {
    this.selectedAssistance.next(null);
  }

  createAssistance(assistance: AssistanceDTO) {
    return this.http.post<Assistance>(this.urlPath, assistance).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  updateAssistance(id: number, assistance: AssistanceDTO & { id: number }) {
    return this.http.put<Assistance>(this.urlPath + id + '/', assistance).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getAssistance(query: QueryGet): Observable<Pagination<Assistance[]>> {
    return this.requestService.get<Assistance[]>(this.urlPath, query);
  }

  getAssistanceById(id: string): Observable<Assistance> {
    return this.http.get<Assistance>(`${this.urlPath}${id}/`);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

    getAssistances(): Observable<Assistance[]> {
      return this.http.get<Assistance[]>(this.url, {
        headers: this.httpOptions.headers,
      });
    }
  
    getOptionAssistance(assistance: Assistance[]): OptionSelect[] {
      return assistance.map((item: Assistance) => {
        return {
          value: item.id ?? '',
          label: item.name,
        };
      });
    }
}
